import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","font-size":"14px"} }, "价格维度", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_9 = { class: "table-responsive" }

import {ref, onMounted, reactive, watch} from "vue";
import ApiService from "@/core/services/ApiService";
import {getCSSVariableValue} from "@/assets/ts/_utils";
import {parseTime} from "@/utils";

// 表格载入延迟

export default /*#__PURE__*/_defineComponent({
  props: {
  apiUrl: { type: String, required: true },
  filters: { type: Object, required: true },
  loading: {type: Boolean, default: false},  // 父组件控制子组件的载入
},
  setup(__props) {

const props = __props

const loading = ref<boolean>(false);
const chart = ref<HTMLElement | null>(null);

const filter = reactive(props.filters as Object);
const title = ref<string>('');
const price_type = ref<string>('saleprice_range');
const fields = reactive({
  saleprice_range: '售价',
  price_range: '吊牌价',
  inprice_range: '成本价',
});
const labelColor = getCSSVariableValue("--bs-" + "gray-800");
const strokeColor = getCSSVariableValue("--bs-" + "gray-300");
const baseColor = getCSSVariableValue("--bs-" + "primary");
const lightColor = getCSSVariableValue("--bs-light-" + "primary");
const series = ref<Array<any>>([]);
const options = reactive({
  chart: {
    type: 'bar',
  },
  plotOptions: {},
  legend: {
    show: true,
    height: 50,
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    opacity: 1,
  },
  xaxis: {
    type: 'category',
    categories: [],  //横坐标数组
  },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      formatter: function(val, index) {
        return val.toFixed(2) + '%';
      }
    }
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + "%"
      }
    }
  }
});

onMounted(() => {
});

watch(props, (val) => {
  if (props.loading) loadData();
});

// 数据载入
const loadData = () => {
  loading.value = true;
  title.value = fields[price_type.value] + '价格分布';
  let params = JSON.parse(JSON.stringify(filter));
  params['price_type'] = price_type.value;
  ApiService.get(props.apiUrl, params).then(({data}) => {
    let fields = {};
    data.fields.map((t:any) => { fields[t['field']] = t });
    options.xaxis.categories = data.data.map(item => item[price_type.value]);
    (chart as any).value.updateOptions(options);
    series.value = [];
    if (data.data.length > 0) {
      // 取出数据中的指标字段名
      let keys = Object.entries(data.data[0]).filter(item => item[0] !== price_type.value).map(item => item[0]);
      // 汇总每个指标值总和
      let amount = {}
      keys.forEach(k => {
        amount[k] = data.data.map(item => item[k]).reduce((amt, item) => amt + item, 0);
      });
      keys.forEach(k => {
        series.value.push({
          name: fields[k]['name'],
          data: data.data.map(item => (item[k] * 100 / amount[k]).toFixed(2) + '%'),
        });
      });
    }
    (chart as any).value.updateSeries(series.value);
    loading.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_el_select, {
          modelValue: price_type.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((price_type).value = $event)),
          size: "small",
          placeholder: "请选择价格维度",
          onChange: loadData,
          style: {"width":"180px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (v, k) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: k,
                key: k,
                label: v
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_apexchart, {
            ref_key: "chart",
            ref: chart,
            type: "bar",
            height: "300",
            options: _unref(options),
            series: series.value,
            class: "mixed-widget-7-chart card-rounded-bottom"
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ]))
}
}

})